import React from "react";
import ArcIcon from "../../../icon";
import styles from "./status.module.scss";

function Priority(props) {
  let { data } = props;
  return (
    <div className={styles.common}>
      <div className={`${styles.wrapper} ${styles["_" + data]}`} >
        <ArcIcon name={data.toLowerCase()} />
        <span>{data}</span>
      </div>
    </div>
  );
}

export default Priority;
